/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.profiles.rpc.ProfilesRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const getRpc = {
  serviceName: 'com.hubspot.marketplace.profiles.rpc.ProfilesRpc',
  rpcName: 'get',
  auth: 'app',
  fingerprint: 'jmowEGoasD8pvSR8CYF2t5wP6LXzGzX8',
  na1Only: true,
  isStreaming: false,
  isHublessAppAuth: false
};
export const doesProfileExistRpc = {
  serviceName: 'com.hubspot.marketplace.profiles.rpc.ProfilesRpc',
  rpcName: 'doesProfileExist',
  auth: 'app',
  fingerprint: '9aRLPdXN0_rcMdSGgs2r55wP6LXzGzX8',
  na1Only: true,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getProfileRpc = {
  serviceName: 'com.hubspot.marketplace.profiles.rpc.ProfilesRpc',
  rpcName: 'getProfile',
  auth: 'app',
  fingerprint: 'vNGHFvrLWrXNzvaEBVjm6JwP6LXzGzX8',
  na1Only: true,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPreviewRpc = {
  serviceName: 'com.hubspot.marketplace.profiles.rpc.ProfilesRpc',
  rpcName: 'getPreview',
  auth: 'app',
  fingerprint: 'ZLD2Xsdqux3oAR20K5IOCJwP6LXzGzX8',
  na1Only: true,
  isStreaming: false,
  isHublessAppAuth: false
};
export const upsertDraftRpc = {
  serviceName: 'com.hubspot.marketplace.profiles.rpc.ProfilesRpc',
  rpcName: 'upsertDraft',
  auth: 'app',
  fingerprint: '6voZmTBkd2Wdk7Qxi8r_YZwP6LXzGzX8',
  na1Only: true,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deleteRpc = {
  serviceName: 'com.hubspot.marketplace.profiles.rpc.ProfilesRpc',
  rpcName: 'delete',
  auth: 'app',
  fingerprint: 'wGhkPeHeHsS2pBl3ntjNlpwP6LXzGzX8',
  na1Only: true,
  isStreaming: false,
  isHublessAppAuth: false
};
export const publishRpc = {
  serviceName: 'com.hubspot.marketplace.profiles.rpc.ProfilesRpc',
  rpcName: 'publish',
  auth: 'app',
  fingerprint: 'srIH5-FAUYdCcOxziuYCPJwP6LXzGzX8',
  na1Only: true,
  isStreaming: false,
  isHublessAppAuth: false
};
export const unpublishRpc = {
  serviceName: 'com.hubspot.marketplace.profiles.rpc.ProfilesRpc',
  rpcName: 'unpublish',
  auth: 'app',
  fingerprint: 'nznJkwfYsHM3dLAJMrmmd5wP6LXzGzX8',
  na1Only: true,
  isStreaming: false,
  isHublessAppAuth: false
};
export const validateSlugRpc = {
  serviceName: 'com.hubspot.marketplace.profiles.rpc.ProfilesRpc',
  rpcName: 'validateSlug',
  auth: 'app',
  fingerprint: 'm-QyPDcJSPzb59oOQG2mTZwP6LXzGzX8',
  na1Only: true,
  isStreaming: false,
  isHublessAppAuth: false
};